import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import MainLayout from '../../../commons/layout/MainLayout/index';

import HeaderHs2 from '../../../commons/components/Header/headerHs2';
import ROUTERS from '../../../commons/constans/router';
import InfiniteScroll from 'react-infinite-scroll-component';
import _styles from './_styles.scss';
import TextInputComponent from '../../../commons/components/Forms/TextInputComponent';
import TextareaComponent from '../../../commons/components/Forms/TextareaComponent';
import API, { ROUTES } from '../../../commons/api/api';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import DropDownCommon from '../../../commons/components/Dropdown';
import DialogComponent from '../../../commons/components/Modal/DialogComponent';

const getBase64Img = async (file) => {
  return new Promise((resolve) => {
    let fileInfo;
    let baseURL = '';
    // Make new FileReader
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);

    // on reader load somthing...
    reader.onload = () => {
      // Make a fileInfo Object
      // console.log("Called", reader);
      baseURL = reader.result;
      // console.log(baseURL);
      resolve(baseURL);
    };
    // console.log(fileInfo);
  });
};

const PreviewImage = (props) => {
  const [img, setImg] = useState(null);
  let file = props.file;
  let index = props.index;
  const removeFileImg = (index) => {};
  getBase64Img(file)
    .then((result) => {
      setImg(result);
    })
    .catch((err) => {
      console.log(err);
    });
  return (
    <div className="attachment__item">
      <div className="input-selector">
        <div className="attachment__item__content">
          <img className="img-show" src={img} />
          {img && (
            <img
              className="icon-del"
              onClick={() => props.removeFile(index)}
              src="/images/icon_del_img.svg"
              alt=""
            />
          )}
        </div>
      </div>
    </div>
  );
};

const QnaCreatePageComponent = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [qnaCategories, setQnaCategories] = useState([]);
  const [renderImage, setRenderImage] = useState([]);
  const [statusSubmit, setStatusSubmit] = useState(false);
  const [indexDel, setIndexDel] = useState(null);
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [dataForm, setDataForm] = useState({
    type: 1,
    subject: '',
    content: '',
    attachment: [],
  });
  const [errorForm, setErrorForm] = useState({
    subject: '',
    content: '',
  });
  const [statusValidate, setStatusValidate] = useState(true);
  const focusFile = useRef(null);
  const [selectType, setSelectType] = useState({
    id: '',
    name: '',
  });

  useEffect(() => {
    let dataList = props?.qnaCategories || [];
    if (dataList.length > 0) {
      let findCateDefault = dataList.filter((item) => item.name == '기타');
      console.log(findCateDefault, 'findCateDefault');
      if (findCateDefault.length > 0) {
        setDataForm({
          ...dataForm,
          type:
            findCateDefault.length > 0 ? findCateDefault[0].id : dataList[0].id,
        });
        setSelectType({
          id: findCateDefault[0].id,
          name: findCateDefault[0].name,
        });
      } else {
        setDataForm({
          ...dataForm,
          type: dataList.length > 0 ? dataList[0].id : dataList[0].id,
        });
        setSelectType({ id: dataList[0].id, name: dataList[0].name });
      }
    }
    setQnaCategories(dataList);
  }, [props?.qnaCategories]);

  const backMenuHome = () => {
    navigate(ROUTERS.HOME, {
      state: {
        menuStatus: true,
      },
    });
  };
  const handleSubmitForm = () => {
    console.log(dataForm, 'handleSubmitForm', statusValidate);
    const formData = new FormData();

    formData.append('content', dataForm.content);
    formData.append('subject', dataForm.subject);
    formData.append('type', dataForm.type);

    if (dataForm.attachment.length > 0) {
      dataForm.attachment.map((item, index) =>
        formData.append('attachment[]', item)
      );
    }

    let validateStatus = validateForm();

    if (validateStatus) {
      setStatusSubmit(true);
      API.post(ROUTES.API_QNA_CREATE, formData)
        .then((res) => {
          console.log(res, 'res 123');
          // setStatusSubmit(false)
          navigate(ROUTERS.QNA);
        })
        .catch((error) => {
          setStatusSubmit(false);
          console.log(error, 'catch error');
        });
    }
  };
  function handleChange(event) {
    console.log(event, 'event123', event.target.value);
    setDataForm({ ...dataForm, type: event.target.value });
  }
  const handleChangeIpt = (e) => {
    console.log(e, 'e123', e.target.value, e.target.name);
    setDataForm({
      ...dataForm,
      [e.target.name]: e.target.value,
    });
    setErrorForm({ ...errorForm, [e.target.name]: '' });
  };
  let myref = null;
  const onFileSelected = async (e) => {
    e.preventDefault();

    let listFile = dataForm.attachment ?? [];
    {
      Object.keys(e.target.files).map((item, i) => {
        if (e.target.files[item].size / 1024 / 1024 > 10) {
          alert('최대 용량 10mb');
        } else {
          listFile.push(e.target.files[item]);
        }
      });
    }
    setDataForm({ ...dataForm, attachment: listFile });
  };

  const handleBrowse = function (e) {
    e.preventDefault();
    focusFile.current.click();
  };
  const validateForm = () => {
    let statusValidate = true;
    let validateContent = !dataForm.content;
    let validateSubject = !dataForm.subject;
    let errorSet = {};
    if (dataForm.subject.length > 20) {
      statusValidate = false;
      errorSet.subject = '제목은  20자 이내 입력 가능합니다.';
      setStatusValidate(false);
    }
    if (dataForm.content.length > 100) {
      statusValidate = false;
      errorSet.content = '내용은 100자 이내 입력 가능합니다.';
      setStatusValidate(false);
    }
    if (validateContent) {
      statusValidate = false;
      errorSet.content = '내용을 입력해주세요.';
      setStatusValidate(false);
    }
    if (validateSubject) {
      statusValidate = false;
      errorSet.subject = '제목을 입력해주세요.';
      setStatusValidate(false);
    } else {
      setStatusValidate(true);
    }
    setErrorForm(errorSet);
    return statusValidate;
  };
  const removeFileRender = (index) => {
		console.log(index, 'removeFileRender');
    setIndexDel(index);
    setIsShowPopup(true);
  };

	const handleDelImg = () => {
		setIsShowPopup(false)
		let listImgRender = dataForm.attachment;
    if (indexDel > -1) {
      listImgRender.splice(indexDel, 1); // 2nd parameter means remove one item only
    }
    setDataForm({ ...dataForm, attachment: listImgRender });
	}

	const handleCloseDel = () => {
		setIsShowPopup(false)
	}

  const changeType = (data) => {
    console.log(data, 'id,name');
    let id = data.id;
    let name = data.name;
    setSelectType({ id: id, name: name });
    setDataForm({ ...dataForm, type: id });
  };

  return (
    <MainLayout pageID={'qna-form'} displayBottomNav={false}>
      <HeaderHs2
        title={'1:1문의'}
        labelLeft={true}
        labelRight={false}
        handleLabelLeft={backMenuHome}
      />
      <div className="wrapper qna-wrapper">
        <div className="container">
          <div className="row m-0">
            <div className="col-12 p-0">
              <div className="input-component">
                <label className="">분류</label>

                <DropDownCommon
                  dataList={qnaCategories}
                  nameDisplay={selectType.name}
                  handleClick={changeType}
                  idActive={selectType.id}
                />

                {/*<div className="input-group select-type">*/}
                {/*    <DropdownButton id="dropdown-item-button" title={`${selectType.name}`}>*/}
                {/*        {qnaCategories.map((item,index) => (*/}
                {/*            <Dropdown.Item as="button" className={selectType.id == item?.id ? 'active' : ''} key={index} onClick={()=>changeType(item.id,item.name)}>*/}
                {/*                {item.name}*/}
                {/*            </Dropdown.Item>*/}
                {/*        ))}*/}
                {/*    </DropdownButton>*/}
                {/*    <img className={'icon-arrow-down'} src={'/images/icon_arrowdown.svg'} />*/}
                {/*</div>*/}
              </div>

              {/*<div className="input-component">*/}
              {/*    <label className="">제목</label>*/}
              {/*    <div className="input-group">*/}
              {/*        <input*/}
              {/*            type="text"*/}
              {/*            placeholder="제목을 입력해주세요."*/}
              {/*            name={'subject'}*/}
              {/*        />*/}
              {/*    </div>*/}
              {/*</div>*/}
              <TextInputComponent
                label={'제목'}
                placeHolder={'제목을 입력해주세요.'}
                id={'id-input-subject'}
                name={'subject'}
                value={dataForm.subject}
                handleChange={handleChangeIpt}
                errorMsg={errorForm?.subject || ''}
              />

              {/*<div className="textarea-component">*/}
              {/*    <label>내용</label>*/}
              {/*    <div className="input-component input-group">*/}
              {/*        <textarea rows="5" placeholder="내용을 입력해주세요." name={'content'}>*/}

              {/*        </textarea>*/}
              {/*    </div>*/}
              {/*</div>*/}

              <TextareaComponent
                label={'내용'}
                placeHolder={'내용을 입력해주세요.'}
                id={'id-content'}
                name={'content'}
                value={dataForm.content}
                rows={8}
                handleChange={handleChangeIpt}
                errorMsg={errorForm?.content || ''}
              />

              <div className="input-component">
                <label className="">참고 이미지</label>
                <div className="attachment">
                  <div className="attachment__item">
                    <div className="input-selector">
                      <input
                        type="file"
                        accept="image/png, image/jpeg, image/jpg, image/jfif,image/gif"
                        name="attachment"
                        ref={focusFile}
                        onChange={onFileSelected}
                      />
                      <div
                        className="attachment__item__content"
                        onClick={handleBrowse}
                      >
                        <img
                          className="12345"
                          src="/images/icon_imageadd.svg"
                        />
                      </div>
                    </div>
                  </div>

                  {dataForm.attachment.map((item, index) => (
                    <PreviewImage
                      file={item}
                      key={index}
                      index={index}
                      removeFile={removeFileRender}
                    />
                  ))}
                </div>
              </div>

              <button
                type="button"
                onClick={handleSubmitForm}
                disabled={statusSubmit}
                className="btn btn-block btn-primary btn-register"
              >
                문의등록
              </button>
            </div>
          </div>
        </div>
      </div>
			<DialogComponent 
          id={`js-confirm-del`} 
          children={``} 
          show={isShowPopup} 
          title={`알림`} 
          customBtn={`확인`}
					closeBtn={`취소`}
          handleCustom={handleDelImg}
					handleClose={handleCloseDel}
          className={``}
        >
          <div className="content-dialog-video-rendering">
            <div className='text'>
            	참고 이미지를 삭제 하시겠습니까?
            </div>
          </div>
        </DialogComponent>
    </MainLayout>
  );
};

export default QnaCreatePageComponent;
